import React from 'react';
import { MenuBar } from './MenuBar';
import { EditorLayout } from '../layout/EditorLayout';
import { useConfigBridge } from '@hooks/useConfigBridge';

export const MainEditor: React.FC = () => {
  // Auto-sync slot game config to slot-core/game.config.json when scene changes
  useConfigBridge();

  return (
    <div className="flex flex-col h-screen bg-zinc-900 text-white">
      {/* Menu Bar */}
      <MenuBar />

      {/* Main Editor Layout */}
      <EditorLayout />
    </div>
  );
};

export default MainEditor;
